export default __webpack_public_path__ + "static/gizapedia_logo_inverse-2e2380c435e67df920f9afe9a14223c6.png";